/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type NameDomainFormValues = {
  name: string;
  domain: string;
};

type Props = {
  nameLabel: string;
  readOnly?: boolean;
  children?: React.ReactNode;
};

export const NameDomainFields = ({ nameLabel, readOnly = false, children }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<NameDomainFormValues>();

  return (
    <>
      <TextField
        label={nameLabel}
        {...register('name')}
        required
        disabled={readOnly}
        error={!!errors.name}
        helperText={errors.name?.message}
      />
      {children}
      <TextField
        label="Domain"
        {...register('domain')}
        placeholder="https://"
        disabled={readOnly}
        error={!!errors.domain}
        helperText={errors.domain?.message}
      />
    </>
  );
};
